import {
  DocumentNode,
  LazyQueryHookOptions,
  OperationVariables,
  QueryTuple,
} from '@apollo/client';

import { useGraphql } from '@sbu/contexts.graphql';
import {
  LazyQueryOptions,
  useLazyQuery as useLazyQueryOriginal,
} from '@sbu/hooks.graphql';

export const useLazyQuery = <
  TData = any,
  TVariables extends OperationVariables = OperationVariables,
>(
  query: DocumentNode,
  options?: LazyQueryHookOptions<TData, TVariables> & LazyQueryOptions
): QueryTuple<TData, TVariables> => {
  const { enableSplitHttpLink } = useGraphql();

  return useLazyQueryOriginal<TData, TVariables>(query, {
    ...options,
    context: {
      ...options?.context,
      targetGraph: 'ADMIRAL',
      enableSplitHttpLink,
    },
  });
};
